import { eventChannel } from "redux-saga";
import { call, fork, take, takeEvery } from "redux-saga/effects";

import { connectSocket, subscribe, unsubscribe } from "../../api/socket";
import showPatientUpdatedNotification from "../../component/Patient/showPatientUpdatedNotification";
import ACTION from "../action";

const UPDATE_EVENT = "update";
const PATIENT_TOPIC = "patient";

function createUpdatesChannel(socket) {
  return eventChannel((emit) => {
    const handler = (payload) => emit(payload || {});
    socket.on(UPDATE_EVENT, handler);
    return () => {
      if (typeof socket.off === "function") socket.off(UPDATE_EVENT, handler);
    };
  });
}

// Guard against late events arriving after the user navigated away from the patient.
function isViewingPatient(patientId) {
  const match = window.location.pathname.match(/\/patient\/(\d+)/);
  return !!match && String(match[1]) === String(patientId);
}

function* watchUpdates() {
  let socket;
  try {
    socket = connectSocket();
  } catch {
    return;
  }
  if (!socket) return;
  const channel = yield call(createUpdatesChannel, socket);
  while (true) {
    const { type, id } = yield take(channel);
    if (type === PATIENT_TOPIC && id != null && isViewingPatient(id)) {
      showPatientUpdatedNotification();
    }
  }
}

function* subscribePatientUpdatesSaga({ patientId }) {
  yield call(subscribe, PATIENT_TOPIC, patientId);
}

function* unsubscribePatientUpdatesSaga({ patientId }) {
  yield call(unsubscribe, PATIENT_TOPIC, patientId);
}

function* socketSaga() {
  // Register the subscribe/unsubscribe watchers first so a connection failure can't prevent them.
  yield takeEvery(ACTION.Types.SUBSCRIBE_PATIENT_UPDATES, subscribePatientUpdatesSaga);
  yield takeEvery(ACTION.Types.UNSUBSCRIBE_PATIENT_UPDATES, unsubscribePatientUpdatesSaga);
  yield fork(watchUpdates);
}

export { socketSaga };
